import {doppeActionTypeDefineMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {DoppeHideableValue} from '../../client-server-common';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeAutomationTriggers,
    doppeHideableValueCreateHidden,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeatures
} from '../../client-server-common';
import type {WixMediaResource} from '@wix/devzai-common-wix';
import type {DoppeCheckoutActionSettings} from '../../client-server-common/types/doppe-checkout-action-settings';
import {
    getDefaultDoppeCheckoutSettingsForAction,
    prepareCheckoutSettingsForViewer
} from '../../client-server-common/types/doppe-checkout-action-settings';
import type {DoppeActionPrice} from '../../client-server-common/types/doppe-action-price';
import type {RichTextContent} from '@wix/devzai-utils-react';

export namespace DoppeActionTypePaidMessage {

    export interface ActionSettings extends
        DoppeCheckoutActionSettings
    {
        title: string;
        description: DoppeHideableValue<RichTextContent>;
        priceData: DoppeActionPrice;
        images: WixMediaResource[] | null;
        previewCheckoutButtonText: string;
    }

}


export const doppeActionTypePaidMessage = doppeActionTypeDefineMetadata<DoppeActionTypePaidMessage.ActionSettings>({
    id: 'co.hopp.action/paid-message',
    resolveActionSettings: action => {

        const {
            checkoutSettings,
            ...restSettings
        } = action.settings;

        return {
            id: '',
            title: '',
            description: doppeHideableValueCreateHidden(''),
            priceData: {
                actualPrice: 0,
                currencyCode: 'USD',
            },
            images: null,
            previewCheckoutButtonText: '',
            ...restSettings,
            checkoutSettings: getDefaultDoppeCheckoutSettingsForAction(checkoutSettings),
        }
    },
    prepareForViewer: actionSettings => {
        prepareCheckoutSettingsForViewer(actionSettings);
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            title: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityTitle),
            description: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            images: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.MultipleMedia, BymoPagePropsContentSettingSemanticMeaning.EntityMedia),
            previewCheckoutButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    isPaymentAction: true,
    getSupportedAutomationTrigger: () => DoppeAutomationTriggers.PaymentReceived,
    isFormAction: false,
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_monetization_actions)
    },
});
